import { StatusStyle } from '../Status/StatusDot';
import { ApprovalStatus } from '../../types/backflowTest';

export const waterSupplierApprovalStatusStyle = (
  approvalStatus?: ApprovalStatus
): StatusStyle => {
  switch (approvalStatus) {
    case 'APPROVED_AUTOMATICALLY':
    case 'APPROVED_MANUALLY':
      return 'success';
    case 'REJECTED':
      return 'error';
    case 'NEEDS_APPROVAL':
      return 'pending';
    case 'UNSUBMITTED':
    case null:
      return 'primary';
    default:
      return 'default';
  }
};

export const waterSupplierApprovalStatusLabel = (
  approvalStatus?: ApprovalStatus
) => {
  switch (approvalStatus) {
    case 'NEEDS_APPROVAL':
      return 'Needs approval';
    case 'APPROVED_AUTOMATICALLY':
    case 'APPROVED_MANUALLY':
      return 'Approved';
    case 'REJECTED':
      return 'Rejected';
    case null:
      return 'Unsubmitted';
    default:
      return '';
  }
};
